import React from "react";

const InformationsLocal = ({
  formData,
  handleChange,
  inputFocus,
  handleTrimValue,
  setFormData,
}) => {
  const listCpVille = [
    { cp: 33510, ville: "Andernos-les-Bains" },
    { cp: 33120, ville: "Arcachon" },
    { cp: 33740, ville: "Arès" },
    { cp: 33980, ville: "Audenge" },
    { cp: 33380, ville: "Biganos" },
    { cp: 33470, ville: "Gujan-Mestras" },
    { cp: 33138, ville: "Lanton" },
    { cp: 33950, ville: "Lège-Cap Ferret" },
    { cp: 33260, ville: "La Teste de Buch" },
    { cp: 33470, ville: "Le Teich" },
    { cp: 33380, ville: "Marcheprime" },
    { cp: 33380, ville: "Mios" },
  ];

  const findCpVille = (event) => {
    const data = listCpVille.find((obj) => obj.ville === event.target.value);
    setFormData((prev) => ({ ...prev, LocAdrCP: data?.cp }));
  };

  return (
    <>
      <header className="d-flex flex-column align-items-center justify-content-center pb-4 pt-4 header">
        <h1 className="title text-center">3. Informations sur le bien</h1>
        <h4 className="text-center">
          Objet de la demande du changement d'usage
        </h4>
        <div className="divider--title m-5"></div>
      </header>
      <section>
        <p className="fw-bold">
          Adresse du bien faisant objet de la demande du changement
          d'usage&nbsp;:
        </p>
        <div className="background--warning p-3">
          <div className="row pb-4">
            <div className="col-12 col-md-3 position-relative">
              <label htmlFor="LocAdrNum" className="form-label">
                Numéro de voie&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                pattern="[0-9]+"
                className="form-control page-3-required inputReg getLabel"
                id="LocAdrNum"
                name="LocAdrNum"
                maxLength={5}
                value={formData.LocAdrNum || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required
              />
              <div className="invalid-tooltip">
                Veuillez entrer un numéro de voie valide
              </div>
            </div>
            <div className="col-12 col-md-3 mt-3 mt-md-0 position-relative">
              <label htmlFor="LocAdrRepetition" className="form-label">
                Indice de répétition&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select page-3-required getLabel"
                aria-label="Default select example"
                id="LocAdrRepetition"
                name="LocAdrRepetition"
                value={formData.LocAdrRepetition || ""}
                onChange={handleChange}
                onInput={inputFocus}
                autoComplete="nope"
                required
              >
                <option defaultValue=""></option>
                <option value="Aucun">Aucun</option>
                <option value="Bis">Bis</option>
                <option value="Ter">Ter</option>
                <option value="Quarter">Quarter</option>
              </select>
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
              <label htmlFor="LocAdrRue" className="form-label">
                Type et nom de voie&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control page-3-required getLabel"
                id="LocAdrRue"
                name="LocAdrRue"
                maxLength={50}
                value={formData.LocAdrRue || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 mt-3 mt-md-0 position-relative">
              <label htmlFor="LocAdrComp" className="form-label">
                Complément d'adresse{" "}
                <span className="text-danger">(facultatif)</span>&nbsp;:
              </label>
              <input
                type="text"
                className="form-control getLabel"
                id="LocAdrComp"
                name="LocAdrComp"
                maxLength={50}
                value={formData.LocAdrComp || ""}
                onInput={inputFocus}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12 col-md-4 position-relative">
              <label htmlFor="LocAdrPorte" className="form-label">
                Porte / Appt <span className="text-danger">(facultatif)</span>
                &nbsp;:
              </label>
              <input
                type="text"
                pattern="[0-9]+"
                className="form-control getLabel"
                id="LocAdrPorte"
                name="LocAdrPorte"
                maxLength={10}
                value={formData.LocAdrPorte || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-4 pt-3 pt-md-0">
              <label htmlFor="LocAdrEscalier" className="form-label">
                Escalier&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control getLabel"
                id="LocAdrEscalier"
                name="LocAdrEscalier"
                maxLength={10}
                value={formData.LocAdrEscalier || ""}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
            <div className="col-12 col-md-4 pt-3 pt-md-0">
              <label htmlFor="LocAdrBat" className="form-label">
                Bâtiment&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control getLabel"
                id="LocAdrBat"
                name="LocAdrBat"
                maxLength={30}
                value={formData.LocAdrBat || ""}
                onChange={handleChange}
                onBlur={handleTrimValue}
                autoComplete="nope"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4 pt-3 pt-md-0 position-relative">
              <label htmlFor="LocAdrCP" className="form-label">
                Code postal&nbsp;:
              </label>
              <input
                list="datalistOptions"
                type="text"
                className="form-control page-3-required inputReg getLabel"
                id="LocAdrCP"
                name="LocAdrCP"
                value={formData.LocAdrCP || ""}
                onChange={handleChange}
                onInput={inputFocus}
                autoComplete="nope"
                disabled
                required
              />

              <div className="invalid-tooltip">
                Veuillez entrer un code postal valide
              </div>
            </div>
            <div className="col-12 col-md-8 pt-3 pt-md-0 position-relative">
              <label htmlFor="ImmLocaliteAdr" className="form-label">
                Commune&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <select
                // si bug, remettre l'id selectOptions
                id="ImmLocaliteAdr"
                className="form-select page-3-required select-group getLabel"
                name="ImmLocaliteAdr"
                value={formData.ImmLocaliteAdr || ""}
                onChange={(e) => {
                  findCpVille(e);
                  handleChange(e);
                }}
                onInput={inputFocus}
                required={formData.LocAdrCP !== ""}
              >
                <option value="">Sélectionnez une commune</option>
                {listCpVille.map((data) => {
                  return (
                    <option value={data.ville} key={data.ville}>
                      {data.ville}
                    </option>
                  );
                })}
              </select>
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="divider mt-5 mb-5"></div>
      <section>
        <label className="mb-2 fw-bold" htmlFor="LocCopro">
          Le bien est-il en copropriété&nbsp;?&nbsp;
          <span className="text-danger">*</span>
        </label>
        <div className="form-check">
          <input
            className="form-check-input page-3-required radio-group getLabel"
            type="radio"
            id="LocCopro"
            name="LocCopro"
            value="Oui"
            onChange={handleChange}
            onInput={inputFocus}
            checked={formData.LocCopro === "Oui" ? true : false}
            data-group="LocCopro"
          />
          <label className="form-check-label">oui</label>
        </div>
        <div className="form-check position-relative">
          <input
            className="form-check-input page-3-required radio-group getLabel"
            type="radio"
            id="LocCopro"
            name="LocCopro"
            value="Non"
            onChange={handleChange}
            onInput={inputFocus}
            checked={formData.LocCopro === "Non" ? true : false}
            data-group="LocCopro"
          />
          <label className="form-check-label">non</label>
          <div className="invalid-tooltip">
            Veuillez remplir ce champs obligatoire
          </div>
        </div>

        {/* *********************************************************************
        div qui passe en d-block en cliquant sur "oui" de la section LocCopro
        ********************************************************************* */}

        <div className={formData.LocCopro === "Oui" ? "d-block" : "d-none"}>
          <div className="row pt-4">
            <div className="col-12 position-relative">
              <label htmlFor="LocAdrNumLot" className="form-label fw-bold">
                N° de lot(s)&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                className="form-control page-3-required LocCopro-group inputReg getLabel"
                type="text"
                id="LocAdrNumLot"
                name="LocAdrNumLot"
                value={formData.LocAdrNumLot || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required={formData.LocCopro === "Oui" ? true : false}
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
          <div className="form-check pt-4 position-relative">
            <input
              id="Check9"
              className={
                formData.LocCopro === "Oui"
                  ? "form-check-input page-3-required LocCopro-group radio-group getLabel"
                  : "form-check-input getLabel"
              }
              type="checkbox"
              name="Check9"
              value="J'atteste sur l'honneur que le règlement de copropriété n'interdit pas le changement d'usage."
              onChange={handleChange}
              onInput={inputFocus}
              checked={
                formData.Check9 ===
                "J'atteste sur l'honneur que le règlement de copropriété n'interdit pas le changement d'usage."
              }
            />
            <label className="form-check-label" htmlFor="Check9">
              J'atteste sur l'honneur que le règlement de copropriété n'interdit
              pas le changement d'usage.
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
      </section>
      <div className="divider mt-5 mb-5"></div>
      <section>
        <div>
          <label className="fw-bold mb-2" htmlFor="LocRezChau">
            Le bien se situe-t-il en rez-de-chaussée&nbsp;?&nbsp;
            <span className="text-danger">*</span>
          </label>
          <div className="form-check">
            <input
              className="form-check-input page-3-required radio-group getLabel"
              type="radio"
              id="LocRezChau"
              name="LocRezChau"
              value="Oui"
              onInput={inputFocus}
              onChange={handleChange}
              checked={formData.LocRezChau === "Oui" ? true : false}
              data-group="LocRezChau"
            />
            <label className="form-check-label">oui</label>
          </div>
          <div className="form-check position-relative">
            <input
              className="form-check-input page-3-required radio-group getLabel"
              type="radio"
              id="LocRezChau"
              name="LocRezChau"
              value="Non"
              onInput={inputFocus}
              onChange={handleChange}
              checked={formData.LocRezChau === "Non" ? true : false}
              data-group="LocRezChau"
            />
            <label className="form-check-label">non</label>
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
        </div>

        {/* ********************************************************************** */}
        {/* div qui passe en d-block lorsque l'on sur non de la section LocRezChau */}
        {/* ********************************************************************** */}

        <div className="row">
          <div
            className={
              formData.LocRezChau === "Non"
                ? "col-12 position-relative d-block"
                : "d-none"
            }
          >
            <label htmlFor="LocEtage" className="form-label fw-bold">
              A quel étage est situé le bien&nbsp;?&nbsp;
              <span className="text-danger">*</span>
            </label>
            <input
              className="form-control page-3-required LocRezChau-group inputReg getLabel"
              type="text"
              pattern="[0-9]+"
              id="LocEtage"
              name="LocEtage"
              maxLength={2}
              value={formData.LocEtage || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              autoComplete="nope"
              required={formData.LocRezChau === "Non" ? true : false}
            />
            <div className="invalid-tooltip">
              Veuillez entrer un numéro d'étage valide
            </div>
          </div>
        </div>
        <div className="divider mt-5 mb-5"></div>
        <div className="row LocMandantStatut">
          <div className="col-12 position-relative">
            <label htmlFor="LocMandantStatut" className="form-label fw-bold">
              Statut du demandeur&nbsp;:&nbsp;
              <span className="text-danger">*</span>
            </label>
            <select
              className="form-select page-3-required select-group getLabel"
              aria-label="Default select example"
              id="LocMandantStatut"
              name="LocMandantStatut"
              value={formData.LocMandantStatut}
              onChange={handleChange}
              onInput={inputFocus}
              required
              disabled
              data-group="LocMandantStatut"
            >
              <option value="Propriétaire">Propriétaire</option>
            </select>
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
        </div>
        <div className="divider mt-5 mb-5"></div>
        <div className="background--warning p-3 mt-4">
          <div className="row">
            <div className="col-12 position-relative">
              <label htmlFor="LocSurface" className="form-label">
                Surface totale habitable en m²&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                className="form-control page-3-required inputReg getLabel"
                type="text"
                pattern="[0-9.]+"
                id="LocSurface"
                name="LocSurface"
                maxLength={10}
                value={formData.LocSurface || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                placeholder="ex: 20, 30 ou 30.5 (Les nombres à virgule ne sont pas acceptés)"
                required
              />
              <div className="invalid-tooltip">
                Veuillez entrer une surface habitable valide
              </div>
            </div>
          </div>
          <div className="row pb-3 pt-md-0">
            <div className="col-12 mt-3 position-relative">
              <label htmlFor="LocNombrePiece" className="form-label">
                Nombre de pièces principales (hors cuisine / wc / salle de
                bains)&nbsp;:&nbsp;<span className="text-danger">*</span>
              </label>
              <input
                className="form-control page-3-required inputReg getLabel"
                type="text"
                pattern="[0-9]+"
                id="LocNombrePiece"
                name="LocNombrePiece"
                maxLength={5}
                value={formData.LocNombrePiece || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                autoComplete="nope"
                required
              />
              <div className="invalid-tooltip">
                Veuillez entrer un nombre de pièces valide
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="divider mt-5 mb-5"></div>
      <section>
        {/* indivision ou demembrement */}
        <div className="">
          <label className="fw-bold mb-2" htmlFor="LocIndiv">
            Le bien est-il détenu en indivision ou en démembrement&nbsp;?&nbsp;
            <span className="text-danger">*</span>
          </label>
          <div className="form-check">
            <input
              className="form-check-input page-3-required radio-group getLabel"
              type="radio"
              id="LocIndiv"
              name="LocIndiv"
              value="Oui"
              onChange={handleChange}
              onInput={inputFocus}
              checked={formData.LocIndiv === "Oui" ? true : false}
            />
            <label className="form-check-label">oui</label>
          </div>
          <div className="form-check position-relative">
            <input
              className="form-check-input page-3-required radio-group getLabel"
              type="radio"
              id="LocIndiv"
              name="LocIndiv"
              value="Non"
              onChange={handleChange}
              onInput={inputFocus}
              checked={formData.LocIndiv === "Non" ? true : false}
            />
            <label className="form-check-label">non</label>
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InformationsLocal;
